import { CSSProperties } from 'react';

import { GalleryJustify } from './enums';

export const galleryJustifyContentMap: Record<
  GalleryJustify,
  CSSProperties['justifyContent']
> = {
  [GalleryJustify.Left]: 'left',
  [GalleryJustify.Center]: 'center',
  [GalleryJustify.Right]: 'right',
  [GalleryJustify.Evenly]: 'space-evenly',
};

export const GALLERY_DEFAULT_JUSTIFY = GalleryJustify.Left;
export const GALLERY_DEFAULT_WITH_TITLE = false;
